export default __webpack_public_path__ + "static/media/wildlife-villarrica-lake.a827245c.jpg";